import React, { useEffect, useRef } from "react";
import { View, Text, Image, ScrollView } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

interface SponsorSectionProps {
  sponsors?: Array<{
    name: string;
    logo: any; // Image source from AppImages
    subtitle?: string;
  }>;
}

const SponsorSection: React.FC<SponsorSectionProps> = ({
  sponsors = [
    { name: "Unity Radio", logo: AppImages.Ko_Sponser_unity_radio },
    { name: "Sponsor 2", logo: AppImages.Ko_Sponser_2 },
    { name: "Sponsor 3", logo: AppImages.Ko_Sponser_3 },
    { name: "Sponsor 4", logo: AppImages.Ko_Sponser_4 },
    { name: "Sponsor 5", logo: AppImages.Ko_Sponser_5 },
    { name: "Sponsor 6", logo: AppImages.Ko_Sponser_6 },
    { name: "Sponsor 7", logo: AppImages.Ko_Sponser_7 },
    { name: "Sponsor 8", logo: AppImages.Ko_Sponser_8 },
    { name: "Sponsor 9", logo: AppImages.Ko_Sponser_9 },
    { name: "Sponsor 10", logo: AppImages.Ko_Sponser_10 },
    { name: "Sponsor 11", logo: AppImages.Ko_Sponser_11 },
  ],
}) => {
  const deviceSize = useDeviceSize();
  const isMobile =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;
  const scrollViewRef = useRef<ScrollView>(null);
  const scrollX = useRef(0);

  // Create a longer list for seamless infinite scroll
  const extendedSponsors = [...sponsors, ...sponsors, ...sponsors];

  useEffect(() => {
    const interval = setInterval(() => {
      if (scrollViewRef.current) {
        // Approximate item width: logo width varies, but with 38px gap (19px each side)
        // Average width estimation for smooth scrolling
        const itemWidth = 150; // Approximate average width + margins
        const totalWidth = sponsors.length * itemWidth;
        scrollX.current += 2;

        // Reset to beginning when we've scrolled past one set of sponsors
        if (scrollX.current >= totalWidth) {
          scrollX.current = 0;
        }

        scrollViewRef.current?.scrollTo({
          x: scrollX.current,
          animated: false,
        });
      }
    }, 50); // Smooth 50ms intervals

    return () => clearInterval(interval);
  }, [sponsors.length]);

  const renderSponsorItem = (sponsor: any, index: number) => {
    return (
      <View
        key={`sponsor-${index}`}
        style={{
          alignItems: "center",
          justifyContent: "center",
          marginHorizontal: isMobile ? 13 : 19, // Mobile: 26px gap, Web: 38px gap
          maxWidth: 150,
        }}
      >
        {sponsor.logo && (
          <Image
            source={sponsor.logo}
            style={{
              height: 40,
              width: 120,
              resizeMode: "contain",
              tintColor: sponsor.logo === AppImages.Ko_Sponser_unity_radio ? undefined : "#FFFFFF",
            }}
          />
        )}
        {sponsor.subtitle && (
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_8,
              {
                color: "#FFA500",
                textAlign: "center",
                fontSize: isMobile ? 6 : 8,
                marginTop: 4,
              },
            ]}
          >
            {sponsor.subtitle}
          </Text>
        )}
      </View>
    );
  };

  return (
    <View
      style={{
        backgroundColor: "#000",
        borderRadius: 6.339,
        borderTopWidth: 0.634,
        borderBottomWidth: 0.634,
        borderTopColor: "rgba(255, 255, 255, 0.40)",
        borderBottomColor: "rgba(255, 255, 255, 0.40)",
        height: 45,
        overflow: "hidden",
        paddingVertical: 2,
      }}
    >
      <ScrollView
        ref={scrollViewRef}
        horizontal
        showsHorizontalScrollIndicator={false}
        scrollEventThrottle={16}
        contentContainerStyle={{
          alignItems: "center",
          height: "100%",
        }}
        style={{
          flex: 1,
        }}
      >
        {extendedSponsors.map((sponsor, index) =>
          renderSponsorItem(sponsor, index)
        )}
      </ScrollView>
    </View>
  );
};

export default SponsorSection;
